import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import RenderOnLocales from '../../../RenderOnLocales';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import {Alignment} from '../../../types';
import {getPageRoute} from '../../../utils/routes/getPageRoute';
import Button, {ButtonVariant} from '../../DesignSystem/Buttons/Button/Button';
import InfoImageBlock from '../../DesignSystem/InfoImageBlock/InfoImageBlock';
import LayoutSection from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection.types';
import Headers, {HeaderType} from '../../DesignSystem/Text/Headers/Headers';
import Paragraph from '../../DesignSystem/Text/Paragraph/Paragraph';
import greenFinanceImageNL from '../../GreenFinance/LendGreen/Lend_green_NL.png';
import greenFinanceImageUK from '../../GreenFinance/LendGreen/Lend_green_UK.png';

import styles from './GreenFinanceInitiative.styles';

function GreenFinanceInitiative(): ReactElement {
  const {formatMessage} = useIntl();
  const locale = useLocale();

  const ImageBlock = (
    <RenderOnLocales
      locales={[Locale.nl]}
      FallbackComponent={
        <img src={greenFinanceImageUK} alt={formatMessage({id: 'greenFinance.GreenFinanceInitiative.imageAlt'})} />
      }
    >
      <img src={greenFinanceImageNL} alt={formatMessage({id: 'greenFinance.GreenFinanceInitiative.imageAlt'})} />
    </RenderOnLocales>
  );

  const InfoBlock = (
    <>
      <Headers headerType={HeaderType.H4} alignment={Alignment.LEFT}>
        <FormattedMessage id="greenFinance.GreenFinanceInitiative.subtitle" />
      </Headers>
      <Headers headerType={HeaderType.H2} alignment={Alignment.LEFT}>
        <FormattedMessage id="greenFinance.GreenFinanceInitiative.title" />
      </Headers>
      <Paragraph>
        <FormattedMessage id="greenFinance.GreenFinanceInitiative.copy1" />
      </Paragraph>
      <Button
        variant={ButtonVariant.PRIMARY}
        href={getPageRoute('greenFinance', locale)}
        ariaLabel={formatMessage({id: 'greenFinance.GreenFinanceInitiative.cta'})}
      >
        <FormattedMessage id="greenFinance.GreenFinanceInitiative.cta" />
      </Button>
    </>
  );

  return (
    <LayoutSection type={LayoutBackground.GRAY}>
      <InfoImageBlock className={cx(styles.imageContainer)} infoBlock={InfoBlock} imageBlock={ImageBlock} isReversed />
    </LayoutSection>
  );
}

export default GreenFinanceInitiative;
